import axois from "axios";
import { EventItem } from "src/modules/chat/models";
import { BaseApiService } from "../api-base";
import { GetEventsRequest } from "./dto";

export class SqlrEventsApiService extends BaseApiService {
  constructor(host: string) {
    super("sqlr");
    this.http = axois.create({
      baseURL: host,
    });
    this.http.interceptors.request.use((config) => {
      config.headers.Authorization = this.jwt;
      return config;
    });
  }

  private getFullPath(method: string) {
    return `${this.url}/rpc/${method}`;
  }

  //#region events
  get_events(params: GetEventsRequest) {
    const method = this.getFullPath("dsv2_get_events");
    const body = params;
    return this.http
      .post<EventItem[]>(method, body)
      .then((response) => response.data);
  }

  get_event(guid: string) {
    const method = this.getFullPath("dsv2_get_event");
    const params = { guid };
    return this.http
      .get<EventItem>(method, { params })
      .then((response) => response.data);
  }
  //#endregion
}
